import { Typography, Box, SxProps, Theme } from '@mui/material';
import React from 'react';

export interface SmallHeaderWithIconAndDescriptionProps {
    title: string;
    Icon?: React.FC<any>;
    description: string;
    customStyle?: SxProps<Theme>;
}

const SmallHeaderWithIconAndDescription: React.FC<
    SmallHeaderWithIconAndDescriptionProps
> = ({ title, Icon, description, customStyle }) => {
    return (
        <Box display="flex" flexDirection="column" gap="3px" sx={customStyle}>
            <Box display="flex" gap={3} alignItems="center">
                {Icon && <Icon color="secondary" size={'24px'} />}
                <Box>
                    <Typography variant="h5" mb="5px">
                        {title}
                    </Typography>
                    <Typography variant="body2" style={{ color: '#5B5B5B' }}>
                        {description}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default SmallHeaderWithIconAndDescription;
